@custom-media --tablet (max-width: 1024px);

.userContainer {
  & > span.userName {
    font-size: 0.9rem;
    font-weight: 300;
    color: var(--white);

    @media (--tablet) {
      display: none;
    }
  }

  & > span.userInitials {
    color: var(--white);
    font-size: 1.15rem;
    padding: 0.1rem 0.2rem;
    display: none;

    @media (--tablet) {
      display: unset;
    }
  }
}
